/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_HeadlineInputs */



/**
* | output |
* | --- |
* | "Tournaments for Vampire: The Eternal Struggle" |
*
* @param {Landing_HeadlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_headline = /** @type {((inputs?: Landing_HeadlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_HeadlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois de Vampire: The Eternal Struggle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneos de Vampire: The Eternal Struggle")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios de Vampire: The Eternal Struggle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornei di Vampire: The Eternal Struggle")
	return /** @type {LocalizedString} */ ("Tournaments for Vampire: The Eternal Struggle")
});